export default __webpack_public_path__ + "static/media/POPPINS-EXTRALIGHTITALIC.ab55e444.TTF";